import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUpdateData } from "./types";

const agentMonitorSlice = createSlice({
    name: 'agentmonitor',
    initialState: {
        updateData: ({} as any) as IUpdateData,
        robocallUpdateData: ({} as any) as IUpdateData,
        
    },
    reducers: {
        agentMonitorRefreshData: (state, action: PayloadAction<IUpdateData>) => {
            state.updateData = action.payload
        },
        robocallMonitorRefreshData: (state, action: PayloadAction<IUpdateData>) => {
            state.robocallUpdateData = action.payload
        },
        agentMonitorWSConnecting: (state) => {
            return;
        }
    },
});

export const {
    agentMonitorRefreshData,
    robocallMonitorRefreshData,
    agentMonitorWSConnecting
} = agentMonitorSlice.actions
export default agentMonitorSlice.reducer

